import type { PricingModel, PricingTemplateType } from '@vy/types';
import { isNullOrUndefined, withDefault } from '@vy/utils';
import { useCallback } from 'react';
import { useGetPricingTemplates } from '../../../../hooks/requests/use-pricing-template';

export const useIsProductConfigurable = () => {
  const response = useGetPricingTemplates({
    suspense: true,
  });

  const pricingTemplates = withDefault(response?.pricingTemplates, []);

  const isProductConfigurable = useCallback(
    (pricingModel: PricingModel, configurationType: PricingTemplateType) => {
      const pricingTemplate = pricingTemplates.find(
        (template) => template.pricingModel === pricingModel && template.templateType === configurationType,
      );

      return isNullOrUndefined(pricingTemplate) || pricingTemplate.userConfigurable;
    },
    [pricingTemplates],
  );

  return isProductConfigurable;
};
